import './TeamDetail.css'
import TeamDescription from "./TeamDescription";
import TeamExperience from "./TeamExperience";
import TeamAvatar from "./TeamAvatar";
import { faPerson, faDesktop, faChartSimple, faPeopleGroup  } from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const TeamDetail = ({user, close}) => {
    return (
        <div className="modal-overlay" onClick={close}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                <button className="modal-close" onClick={close}>
                    &times;
                </button>
                <div className="modal-body">
                    <div className={"container"}>
                        <TeamAvatar name={user.name} role={user.description} photo={user.image}></TeamAvatar>
                        <div className={"row"}>
                            <div className={"col-md-5 col-lg-5 col-sm-12 col-xs-12"}>
                                <div className={"row"}>
                                    <div className={"col-md-12 col-lg-12 col-xs-12 col-sm-12"}>
                                        <div className={"team-detail"}>
                                            <TeamDescription title={"Sa présentation en générale"}
                                                description={user.presentation}
                                                             icon={faPerson}
                                            ></TeamDescription>
                                            <TeamDescription
                                                title={"Son rôle"}
                                                description={user.role}
                                                icon={faDesktop}
                                            ></TeamDescription>
                                            <TeamDescription
                                                title={"Sa contribution envers le projet"}
                                                description={user.contribution}
                                                icon={faPeopleGroup}
                                            ></TeamDescription>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"col-md-1 col-lg-1 col-sm-12 col-xs-12"}></div>
                            <div className={"col-md-5 col-lg-5 col-sm-12 col-xs-12"}>
                                <div className={"row team-experience-container"}>
                                    {/*<div className={"col-md-4 col-lg-4 col-sm-12 col-xs-12"}></div>*/}
                                    <div className={"col-md-12 col-lg-12 col-sm-12 col-xs-12"}>
                                        <h3 className={"team-title"}>Ses expériences professionnelles
                                            &nbsp;
                                            <FontAwesomeIcon icon={faChartSimple} style={{
                                            fontSize: "30px",
                                            color: " var(--green-text)"
                                        }} /></h3>
                                        <ul>
                                            {user.experiences.map((experience) => (
                                                <TeamExperience title={experience.title}
                                                                description={experience.description}
                                                ></TeamExperience>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TeamDetail;
